let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ibkLf")).then(() => parcelRequire('4Ti42'));